import useSteps from './useSteps'
import useCreateAssessment from './useCreateAssessment'
import useStep2 from './useStep2'
import useRatings from './useRatings'
import useUploadFile from './useUploadFile'
import useSyncPendingUploads from './useSyncPendingUploads'
import usePerformSyncUploads from './usePerformSyncUploads'

export default { useRatings, useUploadFile, usePerformSyncUploads, useSyncPendingUploads, useSteps, useStep2, useCreateAssessment }